import { BaleTypeEnum, CarrierType } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { IsOptional } from "class-validator";
import { WorkOrderItemsDto } from "./work-order-items.dto";

export class WorkOrderDto{
    @ApiProperty()
    workOrderId: number;
    @ApiProperty()
    workOrderNo:string;
    @ApiProperty()
    workOrderDate:Date;
     @ApiProperty()
    remarks:string;
    @ApiProperty()
    plantId: number;
    @ApiProperty()
    @IsOptional()
    createdUser: string;

    @ApiProperty()
    @IsOptional()
    updatedUser : string;

    @ApiProperty()
    @IsOptional()
    isActive : boolean;

    @ApiProperty({ type: [WorkOrderItemsDto] })
    workOrderItems: WorkOrderItemsDto[];
    @ApiProperty()
    @IsOptional()
    baleType?:BaleTypeEnum;

}